import ViewControl from "./view-control";

export default ViewControl